import React from 'react'
import { IcDelete } from '../../icons'

export default function Delete({name, handler}) {
    return (
        <button className='text-modelic-error-main' onClick={() => handler(name)} >{IcDelete}</button>
    )
}
